<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              ref="filters"
              :isRequiredFarms="true"
              :isRequiredWorkers="true"
              :filterOfLots="false"
              :filterOfWorkers="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              @onChangeFilters="onChangeFilters"
              classFarms="col-12 col-sm-6 col-md-6"
              classWorkers="col-12 col-sm-6 col-md-6"
            >
            </filter-component>
          </el-collapse-item> </el-collapse
      ></card>
      <div v-if="isIndex()">
        <div v-if="showGraph">
          <card>
            <div class="row">
              <div class="col-12">
                <highcharts :options="lineChartByWeek"></highcharts>
              </div>
              <div class="col-6">
                <highcharts :options="columnChartByFarm"></highcharts>
              </div>
              <div class="col-6">
                <highcharts :options="columnChartByType"></highcharts>
              </div>
              <div class="col-12">
                <highcharts :options="columnChartByWorker"></highcharts>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  mixins: [mixinMasters, MixinMenu, MixinCharts, MixinPermissions],
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }
      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  data() {
    return {
      reportType: 0,
      activeName: 'filter',
      valueCollapse: null,
      dataFilter: {},
      farms: null,
      openCollapse: false,
      chartOptions: [],
      data: [],
      showGraph: false,
      lineChartByWeek: null,
      columnChartByFarm: null,
      columnChartByType: null,
      columnChartByWorker: null,
    };
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.seletedData = {};
      this.dataFilter.end_date = data.datef;
      this.dataFilter.start_date = data.datei;
      this.dataFilter.farms_ids = data.farm;
      this.dataFilter.workers_ids = data.workers;
      this.getListOfDataFilterBySelect();
      this.getDataReport();
    },
    getListOfDataFilterBySelect() {
      const workersIds = this.dataFilter.workers_ids || [];
      const farmsIds = this.dataFilter.farms_ids || [];

      const workersList =
        this.$refs.filters && Array.isArray(this.$refs.filters.workers)
          ? this.$refs.filters.workers
          : [];

      const selectedWorkerSet = new Set(workersIds.map(Number));

      const selectedWorkers = workersList.filter((worker) =>
        selectedWorkerSet.has(Number(worker.id))
      );

      const farmsList =
        this.$refs.filters && Array.isArray(this.$refs.filters.availableFarms)
          ? this.$refs.filters.availableFarms
          : [];

      const selectedFarmSet = new Set(farmsIds.map(Number));

      const selectedFarms = farmsList.filter((farm) =>
        selectedFarmSet.has(Number(farm.id))
      );

      this.dataFilter.workers_list =
        selectedWorkers.length > 0 ? selectedWorkers : [];

      this.dataFilter.farms_list =
        selectedFarms.length > 0 ? selectedFarms : [];
    },
    onChangeFilters() {
      this.showGraph = false;
    },
    getDataReport() {
      this.showGraph = false;
      this.showHideLoading(true);
      let data = this.dataFilter;

      data.route = 'samaria/security';
      Axios.postMasters(data)
        .then((response) => {
          this.data = response.data.data;
          if (this.data.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.showGraph = false;
          } else {
            this.showGraph = true;
            this.lineChartByWeek = this.lines(
              this.data.line_chart_by_week,
              true,
              'auto',
              false
            );
            this.columnChartByFarm = this.columns(
              this.data.column_chart_by_farm
            );
            this.columnChartByType = this.columns(
              this.data.column_by_type_name
            );
            this.columnChartByWorker = this.columns(this.data.column_by_worker);
            this.columnChartByWorker.legend = { enabled: false };
          }
        })
        .catch((error) => {
          this.showMessageErrors(error);
        })
        .finally(() => {
          this.showHideLoading();
        });
    },
  },
};
</script>
